<app-breadcrumb faIcon="fa-bolt" [title]="'Bonus' | transloco"></app-breadcrumb>
<iframe id="bonus-section-iframe" [src]="url" frameborder="0"></iframe>
